import React from 'react';
import type ProjectSettingsServiceDeskAutomationCopyRuleType from '@atlassian/jira-spa-apps-project-settings-service-desk-automation-copy-rule/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationCopyRule = lazyForPaint<
	typeof ProjectSettingsServiceDeskAutomationCopyRuleType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-copy-rule", jiraSpaEntry: "async-project-settings-service-desk-automation-copy-rule" */ '@atlassian/jira-spa-apps-project-settings-service-desk-automation-copy-rule'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationCopyRule}
		pageId="project-settings-automation-copy-rule"
		shouldShowSpinner
	/>
);
